__turbopack_context__.v({
  "badge": "verified-module-scss-module__0vwARq__badge",
  "subtitle": "verified-module-scss-module__0vwARq__subtitle",
  "title": "verified-module-scss-module__0vwARq__title",
  "verified": "verified-module-scss-module__0vwARq__verified",
});
